import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  hasCompletedContent: PropTypes.bool,
  hasPassedContent: PropTypes.bool,
  hasTest: PropTypes.bool,
  lessonInProgress: PropTypes.bool,
  license: PropTypes.bool,
  requiresSubscription: PropTypes.bool,
  marginTop: PropTypes.number,
  mustPassCodingExercise: PropTypes.bool,
  small: PropTypes.bool,
  isActiveForUser: PropTypes.bool,
}

const defaultProps = {
  hasCompletedContent: false,
  hasPassedContent: false,
  hasTest: false,
  lessonInProgress: false,
  license: null,
  requiresSubscription: null,
  marginTop: 20,
  mustPassCodingExercise: false,
  small: false,
  isActiveForUser: undefined,
}

const ContentIcon = ({
  hasCompletedContent,
  hasPassedContent,
  hasTest,
  lessonInProgress,
  license,
  requiresSubscription,
  marginTop,
  mustPassCodingExercise,
  isActiveForUser,
  small,
}) => {
  if (
    (license === false && requiresSubscription === true) ||
    (requiresSubscription && !isActiveForUser)
  ) {
    let icon = 'icon: lock; ratio: 0.9'
    if (small) {
      icon = 'icon: lock; ratio: 0.7'
    }
    return (
      <span
        style={{
          cursor: 'pointer',
          marginRight: 10,
          marginTop,
        }}
        className="uk-inline"
        data-uk-icon={icon}
        data-uk-toggle="target: #modal-content-icon"
      />
    )
  }

  let background = 'none'
  let border = '3px solid #1e87f0'
  let icon = ''
  let width = 15
  let height = 15
  let marginRight = 10
  if (small) {
    width = 10
    height = 10
    marginRight = 5
  }

  if (mustPassCodingExercise === true && hasTest === true && lessonInProgress === true && hasPassedContent === false) {
    background = '#f0506e'
    border = '3px solid #f0506e'
    // color = 'red'
    icon = 'close'
  } else if (hasCompletedContent === true) {
    background = '#1e87f0'
    icon = 'check'
  } else if (lessonInProgress === true) {
    background = '-webkit-linear-gradient(90deg, #1e87f0 50%, #ffffff 50%)'
  }

  return (
    <span
      style={{
        background: `${background}`,
        border,
        width,
        height,
        borderRadius: '50%',
        marginRight,
        marginTop,
        color: '#FFFFFF',
        cursor: 'pointer',
      }}
      className="uk-inline"
      data-uk-icon={icon}
      data-uk-toggle="target: #modal-content-icon"
    />
  )
}

ContentIcon.propTypes = propTypes
ContentIcon.defaultProps = defaultProps

export default ContentIcon
